// extracted by mini-css-extract-plugin
module.exports = {"iconHome":"icon-home_iconHome__LPYX-"};